module.exports = __webpack_public_path__ + "img/02.151b4634.png";